let initialState = "";
const isjoin = (state = "", action) => {

    switch(action.type){ 
      case "SETISJOIN" : return action.parm;
      case "RESET": return initialState; //Always return the initial state
      default : return state;
  }
}

export default isjoin